import React from 'react'
import createMediaQueries from '../../../util/createMediaQueries'
import { css } from 'emotion'

const Box: React.StatelessComponent<any> = ({ is = 'div', ...props }) => {
  props.value = props.value ? props.value : ''
  const styles = props.css ? createMediaQueries(props.css) : {}
  props.className = css(styles)
  const tag = is
  delete props.isValid
  delete props.first
  delete props.last
  return React.createElement(tag, props, props.children)
}

export default Box
